/**
 * Scroll vers le premier champ en erreur dans le formulaire.
 * Cherche un élément avec la classe tw-border-red-500 (appliquée par FormInput/FormSelect/PhoneInput en erreur).
 */
export function scrollToFirstError(): void {
  setTimeout(() => {
    const firstError = document.querySelector('.tw-border-red-500');
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, 100);
}
